// extracted by mini-css-extract-plugin
module.exports = {"icon":"hP7dhyi_iiCF4MflOS3mb"};